// login types
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const SUBMIT_BUTTOM = 'SUBMIT_BUTTON';
export const LOADING_UI = 'LOADING_UI';
export const SET_FILE_LOADING = 'SET_FILE_LOADING';
export const STOP_FILE_LOADING = 'STOP_FILE_LOADING';
export const LOADING_MODAL = 'LOADING_MODAL';
export const SET_LOADING = "SET_LOADING";
export const STOP_LOADING = 'STOP_LOADING';
export const STOP_LOADING_MODAL = 'STOP_LOADING_MODAL';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const CLEAR_MODAL_ERRORS = 'CLEAR_MODAL_ERRORS';
export const LOADING_USER = 'LOADING_USER';
export const SET_ERRORS = 'SET_ERRORS';
export const SET_MODAL_ERRORS = 'SET_MODAL_ERRORS';
export const SET_UNSET_PERMIT_ERRORS = 'SET_UNSET_PERMIT_ERRORS';
export const UI_PROCESSING = 'UI_PROCESSING';


// dynamic Types
export const D_SET_FORM_DATA = 'd_set_form_data';
export const D_CLEAR_FORM_DATA = 'd_clear_form_data';
export const D_SET_APPROVAL_REJECTION_SUCCESS = 'd_set_approval_rejection_success';
export const D_CLEAR_APPROVAL_REJECTION_SUCCESS = 'd_clear_approval_rejection_success';

// file reducer action types
export const F_SET_SUCCESS = 'f_set_success';
export const F_CLEAR_SUCCESS = 'f_clear_success';

// currentForm
export const SET_PREV_DATA = 'd_set_prev_data';
export const SET_APPLICATION_ID = 'd_set_app_id';
export const SET_CURRENT_IDS = 'd_set_current_ids';

// User reducer types
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';
export const SET_UNAUTHENTICATED = 'SET_UNAUTHENTICATED';
export const SET_USER = 'SET_USER';
export const SET_USER_MENU = 'SET_USER_MENU';
export const SET_BUILD_PERMITS = 'SET_BUILD_PERMITS';
export const CLEAR_BUILD_PERMITS = 'CLEAR_BUILD_PERMITS';
export const CLEAR_REJECTED_BY = 'CLEAR_REJECTED_BY';
export const SET_CURRENT_PERMIT = 'SET_CURRENT_PERMIT';
export const SET_CURRENT_DATA = 'SET_CURRENT_DATA';
export const CLEAR_CURRENT_DATA = 'CLEAR_CURRENT_DATA';

// Form Types
export const SET_FORM_DATA = 'SET_FORM_DATA';
export const CLEAR_FORM_DATA = 'CLEAR_FORM_DATA';
export const SET_SUCCESS_FORM_SUBMIT = 'SET_SUCCESS_FORM_SUBMIT';
export const CLEAR_SUCCESS_STATE = 'CLEAR_SUCCESS_STATE';

// Language
export const SET_LANGUAGE = 'SET_LANGUAGE';

//Admin
export const SET_ADMIN_DATA = 'SET_ADMIN_DATA';
export const CLEAR_ADMIN_DATA = 'CLEAR_ADMIN_DATA';
export const SET_SUCCESS_ADMIN_SUBMIT = 'SET_SUCESS_ADMIN_SUBMIT';
export const CLEAR_ADMIN_SUCCESS = 'CLEAR_ADMIN_SUCCESS';

//print

export const SET_PRINT_CONTENT = 'SET_PRINT_CONTENT';

//shortcut

export const SET_SHORTCUT = 'SET_SHORTCUT';

//public section

export const SET_PUBLICDESIGNER_DATA = 'SET_PUBLICDESIGNER_DATA';
export const CLEAR_PUBLICDESIGNER_DATA = 'CLEAR_PUBLICDESIGNER_DATA';
export const SET_PUBLICMASON_DATA = 'SET_PUBLICMASON_DATA';
export const CLEAR_PUBLICMASON_DATA = 'CLEAR_PUBLICMASON_DATA';
export const SET_SUCCESS_PUBLIC_SUBMIT = 'SET_SUCCESS_PUBLIC_SUBMIT';
export const CLEAR_SUCCESS_PUBLIC_SUBMIT = 'CLEAR_SUCCESS_PUBLIC_SUBMIT';
export const SET_PUBLIC_DATA = 'SET_PUBLIC_DATA';
export const CLEAR_PUBLIC_DATA = 'CLEAR_PUBLIC_DATA';

//session types
export const SET_ORGANIZATION_CODE = 'SET_ORG_CODE';
export const CLEAR_ORGANIZATION_CODE = 'CLEAR_ORG_CODE';
export const SET_ORGANIZATION = 'SET_ORGANIZATION';

// ui
export const TOGGLE_NAVBAR = 'TOGGLE_NAVBAR';

//task list 
export const LOADING_TASK_LISTS = 'LOADING_TASK_LISTS';
